import projection from '../generated/pw2503f1.json'; import { AcceptanceManifest } from '../types';
export const pw2503f1AcceptanceManifest = projection as AcceptanceManifest;
